export default __webpack_public_path__ + "static/media/EN_ILO_Organization_Horizontal_RGB_Blue.58443ef1.png";